import { AxiosInstance, AxiosResponse } from "axios";
import { observer } from "mobx-react";
import { useState } from "react";
import useTranslations from "../../core/i18n/useTranslations";
import useUser from "../../core/user/useUser";
import { notify } from "../../ui-lib/components/Alerts/Toast";
import { notifyError } from "../Errors/ErrorAlert";
import PrimeModal from "../../ui-lib/components/PrimeModal/PrimeModal";

const DeleteModal = ({
  isOpen,
  locizeKey,
  title,
  replaceKey,
  callDelete,
  onClose,
  onDelete,
}: {
  isOpen: boolean;
  locizeKey:
    | "alarm_reception"
    | "alarm_handling"
    | "alarm_code"
    | "alarm_code_rule"
    | "administrator"
    | "role_template"
    | "arc_subscription";
  title?: string;
  replaceKey?: string;
  callDelete: (authReq: AxiosInstance) => Promise<AxiosResponse<{}>>;
  onClose: () => void;
  onDelete?: () => void;
}) => {
  const t = useTranslations();
  const { authenticatedRequest } = useUser();

  const [loading, setLoading] = useState(false);

  const getMessageText = () => {
    const splitedMessage = t(`Messages:delete_${locizeKey}_confirm`).split(
      "{replaceKey}"
    );
    return (
      <p>
        {splitedMessage[0]}
        <strong className="grey-900">{replaceKey}</strong>
        {splitedMessage[1]}
      </p>
    );
  };

  const messages = {
    confirm: t(`Messages:delete_${locizeKey}_confirm`),
    success: t(`Messages:delete_${locizeKey}_success`),
  };

  const onSubmit = async () => {
    setLoading(true);
    try {
      await callDelete(authenticatedRequest);
      notify({
        message: messages.success,
      });
      onClose();
      onDelete?.();
    } catch (error: any) {
      notifyError({ error, t });
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <PrimeModal
      withFooter
      withHeader
      isOpen={isOpen}
      header={title || t("Common:delete")}
      onClose={onClose}
      fixedWidth="576px"
      loading={loading}
      submitBtn={{
        text: title || t("Common:delete"),
        variant: "destructive",
        onClick: onSubmit,
      }}
      cancelBtn={{ text: t("Common:cancel"), onClick: onClose }}
    >
      {replaceKey ? (
        getMessageText()
      ) : (
        <p className="grey-600">{messages.confirm}</p>
      )}
    </PrimeModal>
  );
};

export default observer(DeleteModal);
